let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("eNmuD"), load("cM9em"), load("fr9NE"), load("h2MrD"), load("bYT2S"), load("fCxZC")]).then(() => parcelRequire('2wwLq'));